"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cccisdDatepicker = _interopRequireDefault(require("cccisd-datepicker"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross4"));
var _filter = _interopRequireDefault(require("./filter.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FilterDate = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function FilterDate() {
    var _this;
    _classCallCheck(this, FilterDate);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FilterDate, [].concat(args));
    _defineProperty(_this, "_handleChangeStartDate", function (date) {
      var _this$_getDates = _this._getDates(),
        _this$_getDates2 = _slicedToArray(_this$_getDates, 2),
        endDate = _this$_getDates2[1];
      _this.props.onFilterChange(_this.props.column, [(0, _format["default"])(date, 'YYYY-MM-DD'), endDate]);
    });
    _defineProperty(_this, "_handleChangeEndDate", function (date) {
      var _this$_getDates3 = _this._getDates(),
        _this$_getDates4 = _slicedToArray(_this$_getDates3, 1),
        startDate = _this$_getDates4[0];
      _this.props.onFilterChange(_this.props.column, [startDate, (0, _format["default"])(date, 'YYYY-MM-DD')]);
    });
    _defineProperty(_this, "_getDates", function () {
      var _ref = typeof _this.props.value !== 'undefined' ? _this.props.value : [],
        _ref2 = _slicedToArray(_ref, 2),
        startDate = _ref2[0],
        endDate = _ref2[1];
      if (startDate === '') {
        startDate = null;
      }
      if (endDate === '') {
        endDate = null;
      }
      return [startDate, endDate];
    });
    _defineProperty(_this, "_clearStartDate", function () {
      var _this$_getDates5 = _this._getDates(),
        _this$_getDates6 = _slicedToArray(_this$_getDates5, 2),
        endDate = _this$_getDates6[1];
      var newFilter = endDate ? [null, endDate] : '';
      _this.props.onFilterChange(_this.props.column, newFilter);
    });
    _defineProperty(_this, "_clearEndDate", function () {
      var _this$_getDates7 = _this._getDates(),
        _this$_getDates8 = _slicedToArray(_this$_getDates7, 1),
        startDate = _this$_getDates8[0];
      var newFilter = startDate ? [startDate, null] : '';
      _this.props.onFilterChange(_this.props.column, newFilter);
    });
    _defineProperty(_this, "_renderDateField", function (_ref3) {
      var date = _ref3.date,
        placeholder = _ref3.placeholder,
        onChange = _ref3.onChange,
        onClear = _ref3.onClear;
      var value = date || null;
      var cleanButton = value ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _filter["default"].cleanButton,
        onClick: onClear
      }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)) : null;
      var className = (0, _classnames["default"])(_filter["default"].filterBlock, 'd-inline-block', value && _filter["default"].isFilter);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: className
      }, /*#__PURE__*/_react["default"].createElement(_cccisdDatepicker["default"], {
        className: "form-control form-control-sm",
        selected: value,
        onChange: onChange,
        placeholderText: placeholder,
        disabled: _this.props.disabled
      }), cleanButton);
    });
    return _this;
  }
  _inherits(FilterDate, _React$Component);
  return _createClass(FilterDate, [{
    key: "render",
    value: function render() {
      var _this$_getDates9 = this._getDates(),
        _this$_getDates0 = _slicedToArray(_this$_getDates9, 2),
        startDate = _this$_getDates0[0],
        endDate = _this$_getDates0[1];
      var startDatePicker = this._renderDateField({
        date: startDate,
        placeholder: 'from',
        onChange: this._handleChangeStartDate,
        onClear: this._clearStartDate
      });
      var endDatePicker = this._renderDateField({
        date: endDate,
        placeholder: 'to',
        onChange: this._handleChangeEndDate,
        onClear: this._clearEndDate
      });
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _filter["default"].margin
      }, startDatePicker), endDatePicker);
    }
  }]);
}(_react["default"].Component);
_defineProperty(FilterDate, "propTypes", {
  column: _propTypes["default"].string,
  value: _propTypes["default"].array,
  onFilterChange: _propTypes["default"].func,
  settings: _propTypes["default"].object,
  disabled: _propTypes["default"].bool
});